const Mn = require('backbone.marionette');

module.exports = new (Mn.AppRouter.extend({
    initialize: function() {
        if (window.history && window.history.pushState) {
            $(document).on('click', '.push-state', e => {
                e.preventDefault();
                const url = $(e.target).attr('href');
                this.navigate(url, {trigger: true});
            });
        }
    },
    routes: {
        '': 'user',
        'login': 'login',
        'signup': 'signup',
        'connect': 'connect',
        'admin': 'admin',
        'admin/oauth': 'adminOauth'
    },

    user: function() {
        this.trigger('header');
        this.trigger('user');
    },

    login: function() {
        this.trigger('header');
        this.trigger('login');
    },

    signup: function() {
        this.trigger('header');
        this.trigger('signup');
    },

    connect: function() {
        this.trigger('header');
        this.trigger('connect');
    },

    admin: function() {
        this.trigger('admin:header');
        this.trigger('admin');
    },

    adminOauth: function() {
        this.trigger('admin:header');
        this.trigger('admin:oauth');
    }
}))();



// WEBPACK FOOTER //
// ./jiji/app/router/index.js